import * as React from "react";
import { useState } from "react";
import * as Immutable from "immutable";
import ExportTimerangeContextProvider from "logview/components/contexts/ExportTimerangeContextProvider";
import ListStateProvider from "./ListStateProvider";
import ScrollPositionProvider from "./ScrollPositionProvider";
const _getInitialState = ({ after, messages, status }) => ({
  status,
  listState: {
    after,
    loadedPages: { 1: messages },
    loadedMessagesCount: messages.length,
    visiblePagesIds: Immutable.Set([1])
  },
  scrollPositionUpdate: {
    direction: void 0,
    targetPage: void 0,
    targetPageOffsetTop: void 0,
    loadedAllPrevMessages: false
  }
});
const LogViewStateProvider = ({
  initialAfter,
  effectiveTimerange,
  messages,
  tableRef,
  tableHeaderRef,
  pageRefs,
  children,
  onLoadMessages,
  infiniteScrollDirection,
  loadedAllMessages
}) => {
  const [logViewState, setLogViewState] = useState(
    _getInitialState({
      after: initialAfter,
      messages,
      status: "initial"
    })
  );
  const resetListState = () => setLogViewState(
    _getInitialState({
      after: initialAfter,
      messages,
      status: logViewState.status === "initial" ? "reset" : "initial"
    })
  );
  const updateLogViewState = (newLogViewState) => {
    setLogViewState({
      ...newLogViewState,
      status: "update"
    });
  };
  return /* @__PURE__ */ React.createElement(
    ScrollPositionProvider,
    {
      listStateStatus: logViewState.status,
      pageRefs,
      scrollPositionUpdate: logViewState.scrollPositionUpdate,
      infiniteScrollDirection,
      tableHeaderRef,
      tableRef
    },
    /* @__PURE__ */ React.createElement(
      ListStateProvider,
      {
        loadedAllMessages,
        tableRef,
        pageRefs,
        after: logViewState.listState.after,
        infiniteScrollDirection,
        onLoadMessages,
        listState: logViewState.listState,
        updateLogViewState
      },
      /* @__PURE__ */ React.createElement(
        ExportTimerangeContextProvider,
        {
          pages: logViewState.listState.loadedPages,
          effectiveTimerange
        },
        children({ resetListState })
      )
    )
  );
};
export default LogViewStateProvider;
